import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, RotateCcw } from "lucide-react";
import { analectById, quoteLabel } from "../../engine";
import { useGame } from "../../state/GameProvider";

export function LossBanner() {
  const { state, actions } = useGame();
  const analect = analectById.get(state.duel.analectId);
  const show = state.duel.status === "lost" && !state.duel.challenge && analect !== undefined;

  return (
    <AnimatePresence>
      {show && analect && (
        <motion.div className="overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.section
            className="lossbanner"
            initial={{ opacity: 0, y: 22, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.96 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <span className="loss-seal" aria-hidden>
              敗
            </span>
            <h2>本局失利</h2>
            <p className="loss-sub">氣勢已盡——但已破之門仍在，整頓後再破本則。</p>
            <p className="loss-quote">{quoteLabel(analect)}</p>
            <div className="loss-actions">
              <button className="vic-stay" onClick={() => actions.next()}>
                換一則
                <ArrowRight size={15} />
              </button>
              <button className="vic-next" onClick={() => actions.restart()}>
                <RotateCcw size={15} />
                整頓再戰
              </button>
            </div>
          </motion.section>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
